export default function PaymentCard({ icon, amount, title, description }) {
  return (
    <div>
      <div className='wrapper flex card'>
        <div className='flex card price'>
          <div className='icon'>{icon}</div>
          <span className='amount'>{amount}</span>
        </div>
        <div className='flex card'>
          <span className='title'>{title}</span>
          <span className='description'>{description}</span>
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          width: 100%;
          position: relative;
          border-radius: 1rem;
          padding: 3.2rem 0;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
        }

        .icon {
          position: absolute;
          left: 0;
          top: 0;
          padding: 2rem;
        }

        .card {
          flex-direction: column;
          align-items: center;
        }

        .amount {
          padding: 2rem 0 0;
          color: var(--primary-color);
          line-height: 5.8rem;
          font-size: 4.4rem;
          font-weight: 700;
        }

        .title {
          color: var(--primary-text-color);
          line-height: 3rem;
          font-size: 2.2rem;
        }

        .description {
          color: var(--secondary-text-color);
          line-height: 2, 4rem;
          font-size: 1.8rem;
        }

        @media (max-width: 1024px) {
          .wrapper {
            padding: 1.1rem 1.7rem;
            flex-direction: row;

            & > div {
              flex-grow: 1;
              align-items: flex-start;
            }
          }

          .price {
            flex-direction: row;
          }

          .amount {
            padding: 0 0 0 1.7rem;
            line-height: 2.7rem;
            font-size: 2rem;
          }

          .title,
          .description {
            line-height: 1.6rem;
            font-size: 1.2rem;
          }

          .icon {
            padding: 0;
            position: relative;
          }
        }
      `}</style>
    </div>
  )
}
